import { render } from "./NebulaBackground.vue?vue&type=template&id=68e22f62&scoped=true"
import script from "./NebulaBackground.vue?vue&type=script&lang=js"
export * from "./NebulaBackground.vue?vue&type=script&lang=js"

import "./NebulaBackground.vue?vue&type=style&index=0&id=68e22f62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e22f62"]])

export default __exports__